var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            { staticClass: "special-link", attrs: { href: "/mein-konto/" } },
            [_vm._v("\n              Mein Konto\n          ")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            { staticClass: "special-link", attrs: { href: "/kunden-login/" } },
            [
              _vm._v(
                "\n              " +
                  _vm._s(_vm.$translate("Ceres::Template.login")) +
                  "\n          "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }